









































import { Component, Vue, Prop } from 'vue-property-decorator';
import HtmlDisplay from '@/components/atoms/HtmlDisplay.vue';
import PanelContent from '@/components/atoms/PanelContent.vue';
import { i18n } from '@/plugins/i18n/i18n';

@Component({
  components: { HtmlDisplay, PanelContent },
})
export default class PortalNotificationPanel extends Vue {
  private get notification(): string {
    return i18n.tc('portal.notification');
  }
  private get event(): string {
    return i18n.tc('portal.event');
  }

  @Prop()
  private notificationHtml!: string | null;

  private get notificationHtmlWithTitleRemoved(): string | null {
    return this.removeTitle(this.notificationHtml);
  }

  @Prop()
  private eventHtml!: string | null;

  private get eventHtmltWithTitleRemoved(): string | null {
    return this.removeAllEvent(this.removeTitle(this.eventHtml));
  }

  private removeTitle(html: string | null): string | null {
    if (!html) {
      return null;
    }
    const $element: Element | null = this.toElement(html);
    if (!$element) {
      return null;
    }
    if ($element.getElementsByClassName('hs-widget-list').length) {
      const $hsItemTitle = $element.getElementsByClassName('hs-item-title')[0];
      this.removeElement($hsItemTitle);
      const lineClass = 'maincontent_title_underline';
      const $line = $element.getElementsByClassName(lineClass)[0];
      this.removeElement($line);
    } else {
      const $tr = $element.getElementsByTagName('tr')[0];
      this.removeElement($tr);
    }
    return $element.innerHTML;
  }

  private removeAllEvent(html: string | null): string | null {
    if (!html) {
      return null;
    }
    const $element: Element | null = this.toElement(html);
    if (!$element) {
      return null;
    }
    const liList = $element.getElementsByTagName('li');
    if (liList) {
      const $li = liList[liList.length - 1];
      this.removeElement($li);
    }
    return $element.innerHTML;
  }

  private toElement(html: string | null): Element | null {
    if (!html) {
      return null;
    }
    const element = document.createElement('div');
    element.innerHTML = html;
    return element.firstElementChild;
  }

  private removeElement($element: Element | null | undefined) {
    if ($element && $element.parentNode) {
      $element.parentNode.removeChild($element);
    }
  }
}
